// Product flags and constants, same for every environment. Change here, not in .env.
// Imported by vite.config.ts too, so keep it free of import.meta / browser APIs.
export const FEATURES = {
  theme: 'light',
  // Keep equal to KA LAYOUT_CHUNKS_ENABLED.
  layoutChunksEnabled: false,
  layoutChunkConcurrency: 2,
  // VWO -> Amplitude bridge; needs VITE_VWO_ACCOUNT_ID (SmartCode) to be useful.
  vwoAmplitudeBridge: false,
  paymentApiMode: 'commerce',
  dOfferSlug: 'd-offer',
  intercomApiBase: 'https://api-iam.eu.intercom.io',
} as const;
